import React, { useEffect, useState } from 'react';
import { FileText, Download, BookOpen } from 'lucide-react';
import { HERO_IMAGES } from '../mock';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import api, { fileUrl } from '../lib/api';

function fmtBytes(n) {
  if (!n && n !== 0) return '';
  const units = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  while (n >= 1024 && i < units.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(1)} ${units[i]}`;
}

export default function Materials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.listMaterials().then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <div>
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="absolute inset-0">
          <img src={HERO_IMAGES.bibleStudy} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B1B27]/95 via-[#0B1B27]/80 to-[#0B1B27]/50" />
        </div>
        <div className="relative max-w-5xl mx-auto px-4 md:px-6 text-white">
          <p className="text-xs tracking-[0.35em] uppercase text-gold-brand mb-4">Study &amp; Grow</p>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-tight">Written Materials</h1>
          <p className="mt-6 text-lg md:text-xl text-white/80 max-w-3xl">Sermon notes, study guides, and articles to help you go deeper in the Word.</p>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-ivory">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          {items.length === 0 ? (
            <Card className="p-12 bg-white rounded-2xl border border-ink/5 text-center">
              <BookOpen className="h-10 w-10 mx-auto text-teal-deep mb-4" />
              <p className="font-serif-display text-2xl text-ink">Library coming soon</p>
              <p className="text-ink/60 mt-2">Written materials will appear here as the ministry publishes them.</p>
            </Card>
          ) : (
            <div className="grid md:grid-cols-2 gap-5">
              {items.map(m => (
                <Card key={m.id} className="p-6 bg-white rounded-2xl border border-ink/5 hover-lift flex gap-5">
                  <div className="h-16 w-16 rounded-xl bg-cream flex items-center justify-center flex-shrink-0">
                    <FileText className="h-7 w-7 text-teal-deep" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-serif-display text-xl text-ink leading-snug">{m.title}</h3>
                    {m.description && <p className="text-sm text-ink/60 mt-1 line-clamp-2">{m.description}</p>}
                    <p className="text-xs text-ink/40 mt-2">{m.file_name} &middot; {fmtBytes(m.file_size)}</p>
                    <a href={fileUrl(m.file_url)} target="_blank" rel="noreferrer">
                      <Button className="mt-3 bg-teal-brand hover:bg-teal-deep text-white h-9 px-4">
                        <Download className="h-4 w-4 mr-1.5" /> Download
                      </Button>
                    </a>
                  </div>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
